import React from "react";
import { destroyBanner, uploadBanner } from "src/actions/mine_craft/bannersActions";
import { useAppDispatch, useAppSelector } from "src/store/hooks";
import { setNewGroupParams } from "src/store/mine_craft/bannersSlice";

import DrawerRight from "src/componets/DrawerRight";
import GroupUpload from "src/componets/FileDropzone/GroupUpload";
import mineCraftApi from "src/api/mineCraftApi";
import { message } from "antd";

const Dropzone = () => {
  const dispatch = useAppDispatch();
  const newGroupParams = useAppSelector(state => state.mineCraft.banners.newGroupParams);
  const data: any = { app_id: newGroupParams?.app_id };

  function onClose() {
    dispatch(setNewGroupParams(null));
  }

  function handleUploadSuccess(response: any) {
    dispatch(uploadBanner(response));
  }

  function onClickDestroy(file: any) {
    const id = file.response?.banner?.id;
    if (id) {
      handleDestroy(id).catch(console.error);
    }
  }

  async function handleDestroy (id: any) {
    const resultAction = await dispatch(destroyBanner(id));

    if (destroyBanner.fulfilled.match(resultAction)) {
      message.success(`ItemID ${id} was successful deleted`);
    }

    if (destroyBanner.rejected.match(resultAction)) {
      message.error(resultAction.error.message);
    }
  }

  return (
    <DrawerRight
      open={!!newGroupParams}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-newGroup-banner'>
        <h6 className="v-content-label">Banners Dropzone</h6>

        <GroupUpload
          name='image'
          action={mineCraftApi.oneSky.url('/onesky/banners')}
          headers={mineCraftApi.oneSky.uploadHeaders}
          data={data}
          onSuccess={handleUploadSuccess}
          listType='picture'
          onRemove={onClickDestroy}
        />
      </div>
    </DrawerRight>
  )
}

export default Dropzone;
